import http from '../../http'

import type from './type'
import share from './socialShare'
import ticket from './ticket'
import hall from './hall'
import form from './form'
import guest from './guest'
import market from './market'
import schedule from './schedule'
import file from './file'
import person from './person'
import liaison from './liaison'
import resource from './resource'
import wechat from './wechat'
import live from './live'
import screen from './screen'
import activeSession from './activeSession'
import xiezuo from './xiezuo'
let get = (params) => {
  return http.get('activityservice/activitysearch/findone', params)
}

let list = (data) => {
  return http.post('activityservice/activitysearch/page', data)
}

let add = (data) => {
  return http.post('activityservice/activityinfo/insert', data)
}

let update = (data) => {
  return http.post('activityservice/activityinfo/update', data)
}

let getCategory = (data) => {
  // 获取所有的活动类型
  return http.post('opservice/opbasedocactivitytype/list', data)
}

// 获取直播的数据
let getLiveReportData = (data) => {
  return http.post('activityservice/activitylive/bg/count/list', data)
}

// 获取直播的详情数据
let getLiveDetailData = (data) => {
  return http.post('activityservice/activitylive/bg/count/detail/list', data)
}

// 删除活动
let deteleActive = (data) => {
  return http.post('activityservice/activityinfo/delete', data)
}

// 获取回收站列表
let getRecycleList = (data) => {
  return http.post('activityservice/activitysearch/recycle/page', data)
}

let getRecover = (data) => {
  return http.post('activityservice/activitysearch/recycle/do', data)
}
// 活动统计列表
let activeReportList = (data) => {
  return http.post('activityservice/activitysearch/page/detailcount', data)
}

//机构统计列表
let activeCompanyList = (data)=>{
  return http.post('activityservice/statistics/activity/org',data)
}

// 机构参会人数折线图
let peopleNumCanvas = (data)=>{
  return http.post('activityservice/activitysearch/prticipant/count/byorg',data)
}

// 机构活动数折线图
let activeNumCanvas = (data)=>{
  return http.post('activityservice/activitysearch/activity/count/byorg',data)
}

// 导出活动统计列表
let exportActiveReportList = (data) => {
  return http.post('activityservice/activitysearch/page/detailcount/excel', data, {responseType: 'blob' })
}

let exportCompanyReportList = (data) => {
  return http.post('activityservice/statistics/activity/org/down', data, {responseType: 'blob' })
}
export default {
  allActive: (params) => {
    return http.post('activityservice/activitysearch/html/page', params)
  },
  get,
  list,
  add,
  update,
  activeReportList,
  activeCompanyList,
  exportActiveReportList,
  exportCompanyReportList,
  peopleNumCanvas,
  activeNumCanvas,
  market,   // 全员营销
  type,     // 活动分类
  share,    // 活动分享
  ticket,   // 门票管理
  form,     // 表单管理
  hall,     // 分会场管理
  guest,    // 嘉宾管理
  schedule, // 日程管理
  file,     // 文件管理
  person,   // 参会人管理
  liaison,  // 联络人管理
  resource, // 资源配合管理
  wechat,   // 微信签到
  live,     // 直播管理
  screen,   // 大屏幕管理
  activeSession, // 活动统计
  xiezuo, // 协作设计


  signPoint: {
    // 签到点管理
    list: (params) => {
      return http.get('activityservice/activityassistant/query', params)
    },
    person: (params) => {
      return http.post('activityservice/activityassistant/prticipantpage/withcontact', params)
    },
    export: (params) => {
      return http.post('activityservice/activityassistant/signLog/export', params)
    },
  },
  banner:{
    getManage() {
      return http.get('opservice/wechatmanage/get_by_current_user')
    },
    gethomepage(params) {
      return http.get('cmsservice/cms_homepage/get', params)
    },
    savehomepage(params) {
      return http.post('cmsservice/cms_homepage/save', params)
    },
    list(params) {
      return http.get('cmsservice/cms_homebanner/page/list', params)
    },
    save(params) {
      return http.post('cmsservice/cms_homebanner/save', params)
    },
    del(params) {
      return http.post('cmsservice/cms_homebanner/delete', params)
    },
  },
  report: {
    shareRankingCorp: (params) => {
      return http.post('marketcenter/share/groupby/company/detail', params)
    },
    shareRankingPerson: (params) => {
      return http.post('marketcenter/share/groupby/phone/detail', params)
    },
    exportShareRankingCorp: (params) => {
      return http.post('marketcenter/share/groupby/company/detail/export', params)
    },
    exportShareRankingPerson: (params) => {
      return http.post('marketcenter/share/groupby/phone/detail/export', params)
    }
  },

  getCategory, //活动类型  运营平台配置
  // 获取直播的报表数据
  getLiveReportData,
  getLiveDetailData,
  deteleActive,
  getRecycleList,
  getRecover
}
